<app-loader *ngIf="loading" position="absolute"></app-loader>

<form [formGroup]="trayForm">

  <label for="code">
    {{'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.PLACEHOLDERS.code' | translate}}*
  </label>
  <mat-form-field>
    <input id="code" matInput type="text" formControlName="code"
      [placeholder]="'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.PLACEHOLDERS.code'|translate" autocomplete="off">
    <mat-hint>
      {{'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.HINT' | translate}}
      <span [class.on-error]="trayForm.value.code.length>MAX">{{trayForm.value.code.length}}</span>/{{MAX}}
    </mat-hint>
    <mat-error *ngIf="trayForm.controls['code'].hasError('required')">
      {{'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.ERROR.0' | translate}}
    </mat-error>
  </mat-form-field>

  <ng-container *ngIf="!isExtraTray">

    <label for="code">
      {{'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.PLACEHOLDERS.description' | translate}}
    </label>
    <mat-form-field>
      <input id="description" matInput type="text" formControlName="description"
        [placeholder]="'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.PLACEHOLDERS.description'|translate" autocomplete="off">
      <mat-hint>
        {{'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.HINT' | translate}}
        <span
          [class.on-error]="trayForm.value.description?.length>MAX">{{trayForm.value.description?.length}}</span>/{{MAX}}
      </mat-hint>
    </mat-form-field>

  </ng-container>


  <ng-container *ngIf="isExtraTray">

    <label for="referenceDate">
      {{'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.PLACEHOLDERS.referenceDate' | translate}}*
    </label>
    <mat-form-field>
      <input [min]="sharedService.getMinDateEvent(true)" [max]="sharedService.getMaxDateEvent(true)" matInput
        [matDatepicker]="picker" formControlName="referenceDate"
        [placeholder]="'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.PLACEHOLDERS.referenceDate' | translate">
      <mat-datepicker-toggle *ngIf="trayForm.value.referenceDate && !isReadOnlyView()" matSuffix (click)="clearDate()">
        <mat-icon matDatepickerToggleIcon>clear</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker-toggle class="date-picker-toggle" matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-hint>DD/MM/YYYY</mat-hint>
      <mat-error *ngIf="trayForm.controls['referenceDate'].hasError('required')">
        {{'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.ERROR.1' | translate}}
      </mat-error>
      <mat-error *ngIf="trayForm.controls['referenceDate'].hasError('matDatepickerMin')">
        {{'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.ERROR.2' | translate}}
      </mat-error>
      <mat-error *ngIf="trayForm.controls['referenceDate'].hasError('matDatepickerMax')">
        {{'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.ERROR.3' | translate}}
      </mat-error>
    </mat-form-field>

  </ng-container>

  <ng-container *ngIf="isExtraTray">

    <label for="location">
      {{'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.PLACEHOLDERS.location' | translate}}
    </label>
    <mat-form-field>
      <input id="location" matInput type="text" formControlName="location"
        [placeholder]="'PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.PLACEHOLDERS.location'|translate" autocomplete="off">
    </mat-form-field>

  </ng-container>

</form>

<div *ngIf="isReadOnlyView()" class="footer">
  <app-bulgari-button (click)="closeDialog()" [type]="'black'" [customStyle]="{width: '100%', height:'3.5em'}"
    [text]="('PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.CLOSE' | translate) | uppercase">
  </app-bulgari-button>
</div>

<div *ngIf="!isReadOnlyView()" class="">
  <div *ngIf="!isEditMode" class="footer">
    <app-bulgari-button (click)="createTray()" [type]="'black'" [customStyle]="{width: '100%', height:'3.5em'}"
      [text]="('PAGES.PRODUCTS.TRAYS.CREATE_TRAY_DIALOG.CONFIRM' | translate) | uppercase">
    </app-bulgari-button>
  </div>
  <div *ngIf="isEditMode" class="footer edit-mode">
    <app-bulgari-button (click)="cancel()" [type]="'flat'" [customStyle]="{width: '100%'}"
      [text]="('PAGES.PRODUCTS.TRAYS.UPDATE_TRAY_DIALOG.BACK' | translate) | uppercase">
    </app-bulgari-button>
    <app-bulgari-button [disabled]="isDisabledSave()" (click)="updateTray()" [type]="'primary'"
      [customStyle]="{width: '100%'}"
      [text]="('PAGES.PRODUCTS.TRAYS.UPDATE_TRAY_DIALOG.CONFIRM' | translate) | uppercase">
    </app-bulgari-button>
  </div>
</div>
